const orderServicio =
  [
    {
      id:'infoGeneral',
      titulo: "general_info",
      create: [
        {
          type: 'SelectSearch',
          label: 'company',
          class: 'col-md-3 input-form',
          // placeHolder: 'Cliente',
          name: 'NameCustomers',
          selectCatalogName: "Entities",
          id: 'NameCustomers',
          style: {},
          required: true
        },
        {
          type: 'Select',view:true,

          label: 'transport_mode',
          // placeHolder: 'Referencia del cliente',
          name: 'TrasportMode',
          class: 'col-md-3 input-form',
          id: 'TrasportMode',
          options: "TrasportMode",
          selectCatalogName: "CatTransportModes",
          style: {},
          required: true        },
        {
          type: 'Select',view:true,

          label: 'sent_by',
          // placeHolder: 'Referencia del cliente',
          name: 'SistemaEp',
          class: 'col-md-3 input-form',
          id: 'SistemaEp',
          options: "SistemaEp",
          selectCatalogName: "SistemaEp",
          style: {},
          required: true,
          hidden:true,
          disableClearable:true
        },

        {
          type: 'Select',view:true,

          options: 'ServiceType',
          label: 'service_type',
          name: 'ServiceType',
          class: 'col-md-3 input-form',
          id: 'ServiceType',
          selectCatalogName: "CatServiceTypes",
          style: {},
          required: true
        },

        {
          type: 'Select',view:true,

          options: 'ShipmentsType',
          label: 'shipment_type',
          name: 'ShipmentsType',
          class: 'col-md-3 input-form',
          id: 'ShipmentsType',
          id2: 'ShipmentsType2',
          selectCatalogName: "CatShipmentTypes",
          style: {},
          required: true
        },

        {
          type: 'Select',
          view:true,
          options: 'ServiceLevel',
         label: 'service_level',
          name: 'ServiceLevel',
          class: 'col-md-3 input-form',
          id: 'ServiceLevel',
          selectCatalogName: "ServiceLevel",
          style: {},
          required: true
        },

        {
          type: 'Select',view:true,

          options: 'Incoterm',
          label: 'incoterm',
          name: 'Incoterm',
          class: 'col-md-3 input-form',
          id: 'Incoterm',
          selectCatalogName: "Incoterms",
          style: {},
          required: true
        },
        {
          type: 'Select',view:true,
          options: 'Freight',
          label: 'freight_terms',
          name: 'FreightTermCode',
          class: 'col-md-3 input-form',
          id: 'FreightTermCode',
          selectCatalogName: "Freight",
          style: {},
          required: true
        },
        {
          type: 'Select',
          options: 'DL',
          label: 'DL',
          name: 'DL',
          class: 'col-md-3 input-form',
          id: 'DL',
          selectCatalogName: "DL",
          style: {},
          required: false,
          view:true
        },
        {
          type: 'Select',

          options: 'OKAM',
          label: 'OKAM',
          name: 'OKAM',
          class: 'col-md-3 input-form',
          id: 'OKAM',
          selectCatalogName: "OKAM",
          style: {},
          required: false,
          view:true
        },
        {
          type: 'Select',
          options: 'Borders',
          label: 'Border',
          name: 'Borders',
          class: 'col-md-3 input-form',
          id: 'Borders',
          selectCatalogName: "Borders",
          style: {},
          required: false,
          view:false
        },
        {
          type: 'Select',

          options: 'CatAgente',
          label: 'customs_agent',
          name: 'Agente',
          class: 'col-md-3 input-form',
          id: 'Agente',
          selectCatalogName: "CatAgente",
          style: {},
          required: false,
          view:false
        },
        {
          type: 'TextArea',
          label: 'specific_instructions_2',
          name: 'InstruccionesEspecificas',
          class: 'col-md-12 input-form',
          id: 'InstruccionesEspecificas',
          style: {},
          required: false,
          className: 'InstruccionesEspecificas-control'
        }, {
          type: 'TextArea',
          label: 'additional_comments_2',
          name: 'Comentarios',

          class: 'col-md-12 input-form',
          id: 'Comentarios',
          style: {},
          required: false
        }
      ],
      edit: [
        {
          type: 'SelectSearch',
          label: 'company',
          class: 'col-md-3 input-form',
          // placeHolder: 'Cliente',
          name: 'NameCustomers',
          selectCatalogName: "Entities",
          id: 'NameCustomers',
          style: {},
          required: true
        },
        {
          type: 'Select',view:true,

          label: 'transport_mode',
          // placeHolder: 'Referencia del cliente',
          name: 'TrasportMode',
          class: 'col-md-3 input-form',
          id: 'TrasportMode',
          options: "TrasportMode",
          selectCatalogName: "CatTransportModes",
          style: {},
          required: true
        },
        {
          type: 'Select',view:true,

          label: 'sent_by',
          // placeHolder: 'Referencia del cliente',
          name: 'SistemaEp',
          class: 'col-md-3 input-form',
          id: 'SistemaEp',
          options: "SistemaEp",
          selectCatalogName: "SistemaEp",
          style: {},
          required: true,
          hidden:true,
          disableClearable:true
        },

        {
          type: 'Select',view:true,

          options: 'ServiceType',
          label: 'service_type',
          name: 'ServiceType',
          class: 'col-md-3 input-form',
          id: 'ServiceType',
          selectCatalogName: "CatServiceTypes",
          style: {},
          required: true
        },

        {
          type: 'Select',view:true,

          options: 'ShipmentsType',
          label: 'shipment_type',
          name: 'ShipmentsType',
          class: 'col-md-3 input-form',
          id: 'ShipmentsType',
          id2: 'ShipmentsType2',
          selectCatalogName: "CatShipmentTypes",
          style: {},
          required: true
        },

        {
          type: 'Select',
          view:true,
          options: 'ServiceLevel',
         label: 'service_level',
          name: 'ServiceLevel',
          class: 'col-md-3 input-form',
          id: 'ServiceLevel',
          selectCatalogName: "ServiceLevel",
          style: {},
          required: true
        },

        {
          type: 'Select',view:true,

          options: 'Incoterm',
          label: 'incoterm',
          name: 'Incoterm',
          class: 'col-md-3 input-form',
          id: 'Incoterm',
          selectCatalogName: "Incoterms",
          style: {},
          required: true
        },
        {
          type: 'Select',view:true,
          options: 'Freight',
          label: 'freight_terms',
          name: 'FreightTermCode',
          class: 'col-md-3 input-form',
          id: 'FreightTermCode',
          selectCatalogName: "Freight",
          style: {},
          required: true
        },

        {
          type: 'Select',
          options: 'DL',
          label: 'DL',
          name: 'DL',
          class: 'col-md-3 input-form',
          id: 'DL',
          selectCatalogName: "DL",
          style: {},
          required: false,
          view:true
        },

        {
          type: 'Select',

          options: 'OKAM',
          label: 'OKAM',
          name: 'OKAM',
          class: 'col-md-3 input-form',
          id: 'OKAM',
          selectCatalogName: "OKAM",
          style: {},
          required: false,
          view:true

        },
        {
          type: 'Select',
          options: 'Borders',
          label: 'Border',
          name: 'Borders',
          class: 'col-md-3 input-form',
          id: 'Borders',
          selectCatalogName: "Borders",
          style: {},
          required: false,
          view:false
        },
        {
          type: 'Select',

          options: 'CatAgente',
          label: 'customs_agent',
          name: 'Agente',
          class: 'col-md-3 input-form',
          id: 'Agente',
          selectCatalogName: "CatAgente",
          style: {},
          required: false,
          view:false
        },


        {
          type: 'TextArea',
          label: 'specific_instructions_2',
          name: 'InstruccionesEspecificas',

          class: 'col-md-12 input-form',
          id: 'InstruccionesEspecificas',
          style: {},
          required: true,
          className: 'InstruccionesEspecificas-control'
        }, {
          type: 'TextArea',
          label: 'additional_comments_2',
          name: 'Comentarios',

          class: 'col-md-12 input-form',
          id: 'Comentarios',
          style: {},
          required: true
        }
      ],
      editCustomer: [
        {
          type: 'Label',
          view:true,
          label: 'company',
          class: 'col-md-3 input-form',
          // placeHolder: 'Cliente',
          name: 'NameCustomers',
          selectCatalogName: "Entities",
          id: 'NameCustomers',
          style: {},
          required: true
        },
        {
          type: 'Select',view:true,

          label: 'transport_mode',
          // placeHolder: 'Referencia del cliente',
          name: 'TrasportMode',
          class: 'col-md-3 input-form',
          id: 'TrasportMode',
          options: "TrasportMode",
          selectCatalogName: "CatTransportModes",
          style: {},
          required: true
        },
        {
          type: 'Select',view:true,

          label: 'sent_by',
          // placeHolder: 'Referencia del cliente',
          name: 'SistemaEp',
          class: 'col-md-3 input-form',
          id: 'SistemaEp',
          options: "SistemaEp",
          selectCatalogName: "SistemaEp",
          style: {},
          required: true,
          hidden:true,
          disableClearable:true
        },

        {
          type: 'Select',view:true,

          options: 'ServiceType',
          label: 'service_type',
          name: 'ServiceType',
          class: 'col-md-3 input-form',
          id: 'ServiceType',
          selectCatalogName: "CatServiceTypes",
          style: {},
          required: true
        },

        {
          type: 'Select',view:true,

          options: 'ShipmentsType',
          label: 'shipment_type',
          name: 'ShipmentsType',
          class: 'col-md-3 input-form',
          id: 'ShipmentsType',
          id2: 'ShipmentsType2',
          selectCatalogName: "CatShipmentTypes",
          style: {},
          required: true
        },

        {
          type: 'Select',
          view:true,
          options: 'ServiceLevel',
         label: 'service_level',
          name: 'ServiceLevel',
          class: 'col-md-3 input-form',
          id: 'ServiceLevel',
          selectCatalogName: "ServiceLevel",
          style: {},
          required: true
        },

        {
          type: 'Select',view:true,

          options: 'Incoterm',
          label: 'incoterm',
          name: 'Incoterm',
          class: 'col-md-3 input-form',
          id: 'Incoterm',
          selectCatalogName: "Incoterms",
          style: {},
          required: true
        },
        {
          type: 'Select',view:true,
          options: 'Freight',
          label: 'freight_terms',
          name: 'FreightTermCode',
          class: 'col-md-3 input-form',
          id: 'FreightTermCode',
          selectCatalogName: "Freight",
          style: {},
          required: true
        },
        
        {
          type: 'Select',
          options: 'DL',
          label: 'DL',
          name: 'DL',
          class: 'col-md-3 input-form',
          id: 'DL',
          selectCatalogName: "DL",
          style: {},
          required: false,
          view:true
        },

        {
          type: 'Select',

          options: 'OKAM',
          label: 'OKAM',
          name: 'OKAM',
          class: 'col-md-3 input-form',
          id: 'OKAM',
          selectCatalogName: "OKAM",
          style: {},
          required: false,
          view:true

        },
        {
          type: 'Select',
          options: 'Borders',
          label: 'Border',
          name: 'Borders',
          class: 'col-md-3 input-form',
          id: 'Borders',
          selectCatalogName: "Borders",
          style: {},
          required: false,
          view:false
        },
        {
          type: 'Select',

          options: 'CatAgente',
          label: 'customs_agent',
          name: 'Agente',
          class: 'col-md-3 input-form',
          id: 'Agente',
          selectCatalogName: "CatAgente",
          style: {},
          required: false,
          view:false
        },
        {
          type: 'TextArea',
          label: 'specific_instructions_2',
          name: 'InstruccionesEspecificas',

          class: 'col-md-12 input-form',
          id: 'InstruccionesEspecificas',
          style: {},
          required: true,
          className: 'InstruccionesEspecificas-control'
        }, {
          type: 'TextArea',
          label: 'additional_comments_2',
          name: 'Comentarios',

          class: 'col-md-12 input-form',
          id: 'Comentarios',
          style: {},
          required: true
        }
      ],
      previewForm: [
        {
          type: 'Label',
          view:true,
          label: 'company',
          class: 'col-md-3 input-form',
          // placeHolder: 'Cliente',
          name: 'NameCustomers',
          selectCatalogName: "Entities",
          id: 'NameCustomers',
          style: {},
          required: true
        },
        {
          type: 'Label',
          view:true,
          label: 'transport_mode',
          // placeHolder: 'Referencia del cliente',
          name: 'TrasportMode',
          class: 'col-md-3 input-form',
          id: 'TrasportMode',
          options: "TrasportMode",
          selectCatalogName: "CatTransportModes",
          style: {},
          required: true
        },

        {
          type: 'Label',
          view:true,
          label: 'sent_by',
          // placeHolder: 'Referencia del cliente',
          name: 'SistemaEp',
          class: 'col-md-3 input-form',
          id: 'SistemaEp',
          options: "SistemaEp",
          selectCatalogName: "SistemaEp",
          style: {},
          required: true,
        },

        {
          type: 'Label',
          view:true,
          options: 'ServiceType',
          label: 'service_type',
          name: 'ServiceType',
          class: 'col-md-3 input-form',
          id: 'ServiceType',
          selectCatalogName: "CatServiceTypes",
          style: {},
          required: true
        },

        {
          type: 'Label',
          view:true,
          options: 'ShipmentsType',
          label: 'shipment_type',
          name: 'ShipmentsType',
          class: 'col-md-3 input-form',
          id: 'ShipmentsType',
          id2: 'ShipmentsType2',
          selectCatalogName: "CatShipmentTypes",
          style: {},
          required: true
        },
        {
          type: 'Label',
          view:true,
          options: 'ServiceLevel',
         label: 'service_level',
          name: 'ServiceLevel',
          class: 'col-md-3 input-form',
          id: 'ServiceLevel',
          selectCatalogName: "ServiceLevel",
          style: {},
          required: true
        },
        {
          type: 'Label',
          view:true,
          options: 'Incoterm',
          label: 'incoterm',
          name: 'Incoterm',
          class: 'col-md-3 input-form',
          id: 'Incoterm',
          selectCatalogName: "Incoterms",
          style: {},
          required: true
        },
        {
          type: 'Label',
          view:true,
          options: 'Freight',
          label: 'freight_terms',
          name: 'FreightTermCode',
          class: 'col-md-3 input-form',
          id: 'FreightTermCode',
          selectCatalogName: "Freight",
          style: {},
          required: true
        },

        {
          type: 'Label',
          view:true,
          options: 'TransportOrderNo',
          label: 'transport_order_original',
          name: 'Orden de transporte',
          class: 'col-md-3 input-form',
          id: 'TransportOrderNo',
          selectCatalogName: "TransportOrderNo",
          style: {},
          required: true
        },

        {
          type: 'Label',
          view:false,
          options: 'DL',
          label: 'DL',
          name: 'DL',
          class: 'col-md-3 input-form',
          id: 'DL',
          selectCatalogName: "DL",
          style: {},
          required: false,
          view:true
        },
        {
          type: 'Label',
          view:false,
          options: 'OKAM',
          label: 'OKAM',
          name: 'OKAM',
          class: 'col-md-3 input-form',
          id: 'OKAM',
          selectCatalogName: "OKAM",
          style: {},
          required: false,
          view:true
        },
        {
          type: 'Label',
          options: 'Borders',
          label: 'Border',
          name: 'Borders',
          class: 'col-md-3 input-form',
          id: 'Borders',
          selectCatalogName: "Borders",
          style: {},
          required: false,
          view:false
        },
        {
          type: 'Label',

          options: 'CatAgente',
          label: 'customs_agent',
          name: 'Agente',
          class: 'col-md-3 input-form',
          id: 'Agente',
          selectCatalogName: "CatAgente",
          style: {},
          required: false,
          view:false
        },
        {
          type: 'Label',
          view:true,
          label: 'specific_instructions_2',
          name: 'InstruccionesEspecificas',
          class: 'col-md-12 input-form',
          id: 'InstruccionesEspecificas',
          style: {},
          required: true,
          className: 'InstruccionesEspecificas-control'
        },
         {
          type: 'Label',
          view:true,
          label: 'additional_comments_2',
          name: 'Comentarios',

          class: 'col-md-12 input-form',
          id: 'Comentarios',
          style: {},
          required: true
        }
      ]
    },
    {
      id:'inOrdenes',
      titulo: "information",
      img: "",
      create: [
        {
          type: 'CheckboxCicule',
          label: 'type',
          class: 'col-md-6 input-form',
          placeHolder: 'TypeOrder',
          name: 'TypeOrder',
          selectCatalogName: [{id:1, label: "request"}, {id:2, label: 'purchase_order',disabled:false}],
          id: 'TypeOrder',
          style: {},
          required: true
        },
        {
          type: 'Bottom',
          class: 'col-md-6 input-form',
          labelBottom: 'add_eliminate',
          id: 'BottomOs',
        },
        {
          type: 'Label',
          view:true,
          label: 'total_shipping_lines',
          class: 'col-md-3 input-form',
          placeHolder: '',
          name: 'lineCarge',
          id: 'lineCarge',
          style: {},
          required: false,
          disabled:true
        },
        //  {
        //   type: 'Space',
        //   class: 'col-md-6 input-form',
        // },
        {
          type: 'Label',
          view:true,
          label: 'total_weight',
          class: 'col-md-3 input-form',
          placeHolder: '',
          name: 'totalweights',
          id: 'totalweights',
          style: {},
          required: false,
          disabled:true,
          separador:true
        },
        {
          type: 'Label',
          view:true,
          label: 'qty_ordered',
          class: 'col-md-3 input-form',
          placeHolder: '',
          name: 'QTYConfirmated',
          id: 'QTYConfirmated',
          style: {},
          required: false,
          disabled:true,
          separador:true
        },
        {
          type: 'Table',
          class: 'col-md-3',
          id: 'TableOs',
          selectedOs: [],
          class: 'col-md-12',
          // required: true
        },
      ],
      edit: [
        {
          type: 'CheckboxCicule',
          label: 'type',
          class: 'col-md-6 input-form',
          placeHolder: 'TypeOrder',
          name: 'TypeOrder',
          selectCatalogName: [{id:1, label: 'request'}, {id:2, label: 'purchase_order',disabled:false}],
          id: 'TypeOrder',
          style: {},
          required: true
        },
        {
          type: 'Bottom',
          class: 'col-md-6 input-form',
          labelBottom: 'add_eliminate',
          id: 'BottomOs',
        },
        {
          type: 'Label',
          view:true,
          label: 'total_shipping_lines',
          class: 'col-md-3 input-form',
          placeHolder: '',
          name: 'lineCarge',
          id: 'lineCarge',
          style: {},
          required: false,
          disabled:true
        },
        //  {
        //   type: 'Space',
        //   class: 'col-md-6 input-form',
        // },
        {
          type: 'Label',
          view:true,
          label: 'total_weight',
          class: 'col-md-3 input-form',
          placeHolder: '',
          name: 'totalweights',
          id: 'totalweights',
          style: {},
          required: false,
          disabled:true,
          separador:true
        },
        {
          type: 'Label',
          view:true,
          label: 'qty_ordered',
          class: 'col-md-3 input-form',
          placeHolder: '',
          name: 'QTYConfirmated',
          id: 'QTYConfirmated',
          style: {},
          required: false,
          disabled:true,
          separador:true
        },
        {
          type: 'Table',
          class: 'col-md-3',
          id: 'TableOs',
          selectedOs: [],
          class: 'col-md-12',
          // required: true
        },
      ],
      editCustomer: [
        {
          type: 'CheckboxCicule',
          label: 'type',
          class: 'col-md-6 input-form',
          placeHolder: 'TypeOrder',
          name: 'TypeOrder',
          selectCatalogName: [{id:1, label: 'request'}, {id:2, label: 'purchase_order',disabled:false}],
          id: 'TypeOrder',
          style: {},
          required: true
        },
        {
          type: 'Bottom',
          class: 'col-md-6 input-form',
          labelBottom: 'add_eliminate',
          id: 'BottomOs',
        },
        {
          type: 'Label',
          view:true,
          label: 'total_shipping_lines',
          class: 'col-md-3 input-form',
          placeHolder: '',
          name: 'lineCarge',
          id: 'lineCarge',
          style: {},
          required: false,
          disabled:true
        },
        //  {
        //   type: 'Space',
        //   class: 'col-md-6 input-form',
        // },
        {
          type: 'Label',
          view:true,
          label: 'total_weight',
          class: 'col-md-3 input-form',
          placeHolder: '',
          name: 'totalweights',
          id: 'totalweights',
          style: {},
          required: false,
          disabled:true,
          separador:true
        },
        {
          type: 'Label',
          view:true,
          label: 'qty_ordered',
          class: 'col-md-3 input-form',
          placeHolder: '',
          name: 'QTYConfirmated',
          id: 'QTYConfirmated',
          style: {},
          required: false,
          disabled:true,
          separador:true
        },
        {
          type: 'Table',
          class: 'col-md-3',
          id: 'TableOs',
          selectedOs: [],
          class: 'col-md-12',
          // required: true
        },
      ],
      previewForm: [
        {
          type: 'Label',
          view:true,
          check:true,
          label: 'type',
          class: 'col-md-3 input-form',
          placeHolder: 'TypeOrder',
          name: 'TypeOrder',
          selectCatalogName: [{id:1, label: 'request'}, {id:2, label: 'purchase_order',disabled:false}],
          id: 'TypeOrder',
          style: {},
          required: true
        },
        // {
        //   type: 'Bottom',
        //   class: 'col-md-6 input-form',
        //   labelBottom: 'Agregar/Quitar',
        //   id: 'BottomOs',
        // },
        {
          type: 'Label',
          view:true,
          label: 'total_shipping_lines',
          class: 'col-md-3 input-form',
          placeHolder: '',
          name: 'lineCarge',
          id: 'lineCarge',
          style: {},
          required: false,
          disabled:true
        },
        //  {
        //   type: 'Space',
        //   class: 'col-md-6 input-form',
        // },
        {
          type: 'Label',
          view:true,
          label: 'total_weight',
          class: 'col-md-3 input-form',
          placeHolder: '',
          name: 'totalweights',
          id: 'totalweights',
          format: 'weight',
          style: {},
          required: false,
          disabled:true,
          separador:true
        },
        {
          type: 'Label',
          view:true,
          label: 'qty_ordered',
          class: 'col-md-3 input-form',
          placeHolder: '',
          name: 'QTYConfirmated',
          id: 'QTYConfirmated',
          style: {},
          required: false,
          disabled:true,
          separador:true
        },
        {
          type: 'Table',
          class: 'col-md-3',
          id: 'TableOs',
          selectedOs: [],
          class: 'col-md-12',
          // required: true
        },
      ]
    },
  ]


export default orderServicio